/* eslint-disable simple-import-sort/imports */
import { createComponentWrapperWithRef, styled } from '../../theme'
import React, { ReactElement } from 'react'

import { COLORS } from '../../theme/colors'
import { E2eTag } from '../../utils'
import { ButtonAlignProps } from './ButtonAlignProps'
import { ButtonBase } from './ButtonBase'
/* eslint-enable simple-import-sort/imports */

const MuiStyledButton = styled(ButtonBase, { shouldForwardProp: (prop) => prop !== '$alignLeft' })<{
  $alignLeft?: boolean
}>`
  border: 1px solid ${COLORS.primary.outlinedBorder};
  border-radius: 20px;
  padding: 8px 24px;
  height: 40px;
  font-size: 0.938rem;
  font-weight: 700;
  line-height: 160%;
  text-transform: unset;
  ${({ $alignLeft }) => ($alignLeft ? 'margin-right: auto;' : '')}

  &:hover {
    background-color: ${COLORS.primary.hover};
    border: 1px solid ${COLORS.primary.outlinedBorder};
  }
`

const NovaStyledButton = styled(ButtonBase, { shouldForwardProp: (prop) => prop !== '$alignLeft' })<{
  $alignLeft?: boolean
}>`
  ${({ $alignLeft }) => ($alignLeft ? 'margin-right: auto;' : '')}
`

const StyledButton = createComponentWrapperWithRef(
  {
    mui: MuiStyledButton,
    nova: NovaStyledButton,
  },
  'StyledButtonSecondary',
)

// eslint-disable-next-line import/no-unused-modules
export function ButtonSecondary({ alignLeft, ...props }: ButtonAlignProps): ReactElement & E2eTag {
  return (
    <StyledButton $alignLeft={alignLeft} variant="outlined" {...props}>
      {props.children}
    </StyledButton>
  )
}
